import { SVGProps } from 'react';

const Scale3D = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 7v11a1 1 0 0 0 .293.707M5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.293 11.707A1 1 0 0 0 6 19h11m-11.707-.293L11 13m6 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
    />
  </svg>
);
export default Scale3D;
